import { dateISOIn } from 'Data/format.js'
import { getEffectiveStartDate } from 'Data/payment-plan.js'

export function getText(insured) {
  let insurance_company_name =
    insured.insurance_subscription.insurance_plan.insurance_billing_center
      ?.name ??
    insured.insurance_subscription.insurance_plan.insurance_company.carrier_name
  let effective_date = getEffectiveStartDate(insured)
  return effective_date
    ? `${insurance_company_name}, ${dateISOIn(effective_date)}`
    : insurance_company_name
}
